import Layout from './../Layout'; // Assuming Layout component is in the parent directory
import { Phone, Mail, MapPin, Globe, MessageCircle } from "lucide-react"; // Importing icons from lucide-react

export default function Contact() {
  return (
    <Layout pageTitle="Get in Touch">
        <p className="text-gray-700 text-center mb-6">
          Feel free to reach out to us through any of the following channels.
        </p>

        <div className="space-y-4 text-gray-700">
          {/* Mobile Phone Number */}
          <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors">
            <Phone className="text-blue-600 w-6 h-6" /> {/* Larger, more prominent icon color */}
            <a href="tel:+94771416733" className="hover:underline text-lg font-medium">+94 77 141 6733</a>
          </div>

          {/* Land Phone Number */}
          <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors">
            <Phone className="text-blue-600 w-6 h-6" /> {/* Consistent icon styling */}
            <a href="tel:+94572052585" className="hover:underline text-lg font-medium">+94 57 205 2585</a>
          </div>

          {/* WhatsApp Chat */}
          <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors">
            <MessageCircle className="text-green-500 w-6 h-6" /> {/* WhatsApp green */}
            <a href="https://wa.me/94778786733" target="_blank" rel="noopener noreferrer" className="hover:underline text-lg font-medium">
              WhatsApp Chat
            </a>
          </div>

          {/* Email Address */}
          <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors">
            <Mail className="text-red-500 w-6 h-6" /> {/* Email icon color */}
            <a href="mailto:info@woodchaletsella.com.lk" className="hover:underline text-lg font-medium">info@woodchaletsella.com.lk</a>
          </div>

          {/* Physical Address */}
          <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors">
            <MapPin className="text-purple-600 w-6 h-6" /> {/* Map icon color */}
            <span className="text-lg font-medium">Maduragama Junction, Hela Halpe Bandarawela</span>
          </div>

          {/* Website Link */}
          <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors">
            <Globe className="text-indigo-600 w-6 h-6" /> {/* Globe icon color */}
            <a href="https://woodchaletsella.com.lk" target="_blank" rel="noopener noreferrer" className="hover:underline text-lg font-medium">
              woodchaletsella.com.lk
            </a>
          </div>
        </div>
    </Layout>
  );
}
